import React, { createContext, useContext, useState, useEffect } from 'react';
import { demarrer as demarrerPosition, arreter as arreterPosition } from './position';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); }
    catch { return null; }
  });

  // Rafraîchir les permissions depuis /me à chaque démarrage de l'app
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/auth/me', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data) {
          const updated = { ...user, ...data };
          localStorage.setItem('user', JSON.stringify(updated));
          setUser(updated);
        }
      })
      .catch(() => {});
  }, []);

  // Le suivi de position suit la session : il demarre des qu'un technicien
  // est connecte, s'arrete a la deconnexion, et ne se demande rien d'autre.
  // Le navigateur reclame l'autorisation la premiere fois, une seule fois.
  useEffect(() => {
    if (user) demarrerPosition(); else arreterPosition();
  }, [user]);

  const signIn = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    arreterPosition();
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading: false, signIn, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
